var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ecb65acf5ffb31048a2d69a3142a541.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6f32995eda672a4acf1ac2957bc44ba8.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0ed4f0bf88730d4f81cc818ab3349e9.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    